module.exports = __webpack_public_path__ + "static/nothing-fake-you-cant-pronounce-a1adc85228556b0269641cb037cbe848.svg";